// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__203df","header":"MessagesList_header__28Yva","chat":"MessagesList_chat__15nkr"};